import React, { ReactNode, useContext } from 'react';
import { AgencyProps } from './DetailsInfo.types';
import { DetailsInfoType } from '../MapPage.types';
import { Stack } from 'office-ui-fabric-react';
import { mapContext } from '../mapContext';
import { typeSafeObjectKeys } from './typings';
import { agencyStrings, vehicleStrings } from './consts';
import { Styled } from './DetailsInfo.styles';

export const AgencyInfo: React.FC<AgencyProps> = ({ id, type }) => {
  const { agenciesFilters } = useContext(mapContext);
  let item: { address: string; phone: string; title: string } | undefined;
  switch (type) {
    case DetailsInfoType.agency:
      item = agenciesFilters.agencies.find((ag) => ag.agency_id === id);
      break;
    case DetailsInfoType.department:
      item = agenciesFilters.departments.find((de) => de.td_id === id);
      break;
    case DetailsInfoType.depot:
      item = agenciesFilters.depots.find((dp) => dp.depot_id === id);
      break;
  }

  if (!item) return null;

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      {typeSafeObjectKeys(agencyStrings).map((key) => {
        let data: ReactNode = null;
        switch (key) {
          case 'address':
          case 'title':
            data = item?.[key];
            break;
          case 'phone':
            data = <a href={'tel:' + item?.phone}> {item?.phone}</a>;
        }
        return (
          <Styled.InfoRow key={key}>
            <Styled.InfoRowTitle>{agencyStrings[key]}</Styled.InfoRowTitle>
            <Styled.InfoRowData>{data || ' - '}</Styled.InfoRowData>
          </Styled.InfoRow>
        );
      })}
    </Stack>
  );
};
